export default __webpack_public_path__ + "static/media/Group 3057.4946f547.png";